import { ToggleButton, ToggleButtonGroup } from '@zillow/constellation-10';
import { Controller, useFormContext } from 'react-hook-form';
import { FIELD_IDS } from '../../../../constants/wizard';
import { SettingCard } from './SettingCard';
import { VehiclesList } from './VehiclesList';

const HAS_VEHICLES_LABEL = 'Do you have a car?';
const HAS_VEHICLES_LABEL_ID = 'hasVehicles-label';

export function VehiclesSection() {
  const { watch } = useFormContext();
  const hasVehicles = watch(FIELD_IDS.HAS_VEHICLES);

  return (
    <>
      <Controller
        name={FIELD_IDS.HAS_VEHICLES}
        render={({ field: { onChange, onBlur, value } }) => (
          <SettingCard label={HAS_VEHICLES_LABEL} labelId={HAS_VEHICLES_LABEL_ID} isStackedOnMobile>
            <ToggleButtonGroup
              aria-label={HAS_VEHICLES_LABEL}
              size="sm"
              fluid
              value={value == null ? '' : String(value)}
              onValueChange={(newValue) => onChange(newValue === 'true')}
              onBlur={onBlur}
              css={{ width: { lg: '208px' }, flexShrink: 0 }}
            >
              <ToggleButton value="true">Yes</ToggleButton>
              <ToggleButton value="false">No</ToggleButton>
            </ToggleButtonGroup>
          </SettingCard>
        )}
      />
      {hasVehicles === true && <VehiclesList />}
    </>
  );
}
